import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../Core/RichText';
import BannerBlock from '../../Banners/BannerBlock';
import PageBuilder from '../../../Core/PageBuilder';
import { PointsTileCards } from '../../Card-Sections/PointsTiles';

import {
  Heading,
  ContentWrapper,
  StyledCtas,
  Wrapper,
  Disclaimer,
} from './styles';

const pageTemplate = {
  'points-feature-section': PointsTileCards,
  'banner-block': BannerBlock,
};

const CarouselAndBannerSection = ({ data }) => {
  if (!data) return null;

  const {
    anchorName,
    backgroundColor,
    contentAlignment,
    elements,
    sectionContainerHeading,
    sectionContainerHeadingColor,
    sectionSubheading,
    ctas,
    legalCopy,
  } = data;

  const header = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Heading
          contentAlignment={contentAlignment}
          headingColor={sectionContainerHeadingColor}
        >
          {children}
        </Heading>
      ),
      [BLOCKS.HEADING_2]: (_, children) => (
        <Heading
          contentAlignment={contentAlignment}
          headingColor={sectionContainerHeadingColor}
        >
          {children}
        </Heading>
      ),
    },
  };

  const disclaimer = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <Disclaimer>{children}</Disclaimer>,
    },
  };

  return (
    <Wrapper id={anchorName} bgColor={backgroundColor}>
      {sectionContainerHeading && (
        <RichText document={sectionContainerHeading} options={header} />
      )}
      {sectionSubheading && <RichText document={sectionSubheading} />}
      <ContentWrapper className={contentAlignment}>
        {elements && (
          <PageBuilder
            sections={elements}
            template={pageTemplate}
            className="carousel-banner-section"
          />
        )}
        {legalCopy && <RichText document={legalCopy} options={disclaimer} />}
        {ctas && <StyledCtas ctas={ctas} direction="row" />}
      </ContentWrapper>
    </Wrapper>
  );
};

CarouselAndBannerSection.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default CarouselAndBannerSection;
